import { makeStyles } from '@material-ui/core/styles';

const useWizardStepStyles = makeStyles({
  stepperContainer: {
    marginTop: '1.7rem', // Comes from next/back button margin + top padding (1 + ~0.7)
  },
  root: {
    maxWidth: 1000,
    flexGrow: 1,
    backgroundColor: 'transparent',
  },
  active: {
    backgroundColor: 'var(--primary)',
  },
});

export default useWizardStepStyles;
